import { Address } from "../../address";
import { TradableWallet } from "../../interfaces/tradable_wallet";

export abstract class DerivativeWallet extends TradableWallet {
	public getAddresses(): Address[] {
		return [];
	}

	public setAddresses(addresses: Address[]): void {
		// Override only
	}

	public isDerivative(): boolean {
		return true;
	}
}
